<script lang="ts">
  import { Button } from "sveltestrap";
  import { navigate } from "svelte-routing";
  import Fa from "svelte-fa";
  import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
</script>

<main>
  <h1>CREDITS</h1>
  <div class="d-flex flex-column instructions mt-3">
    <p>
      Created by <a href="https://www.jwestman.net/">James Westman</a> for a game development class.
    </p>
    <p>
      Made with <a href="https://svelte.dev/">Svelte</a>, <a href="https://fontawesome.com/">Font Awesome</a>,
      and <a href="https://getbootstrap.com/">Bootstrap</a>.
      Fonts are <a href="https://fonts.google.com/specimen/Barlow+Condensed">Barlow Condensed</a>,
      licensed under the Open Font License, and <a href="https://fonts.google.com/specimen/Roboto+Slab">Roboto Slab</a>,
      licensed under Apache 2.0.
    </p>
    <Button
      size="lg"
      color="dark"
      class="mt-3 sans"
      outline
      on:click={() => navigate("/")}
    >
      <Fa icon={faArrowLeft} />
      BACK
    </Button>
  </div>
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1em;
    margin: 0 auto;
    font-family: "Roboto Slab";
  }

  h1 {
    text-align: center;
    margin: 0;
    font-family: "Barlow Condensed";
    text-transform: uppercase;
    font-size: 10em;
    font-weight: bold;
    line-height: 0.9;
  }

  .instructions {
    max-width: 75%;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
